// Module
var code = "<div class=\"grid-manager\">\n  <cs-widget v-for=\"widget in dashboard.widgets\" :key=\"widget.id\" :widget=\"widget\"></cs-widget>\n</div>\n";
// Exports
module.exports = code;